export { MoneyCalculator } from "./MoneyCalculator";
export default {
  sumUpPrices(prices) {
    if (!prices || prices.length === 0) return "";
    const sum = prices.reduce((a, b) => a + b);
    if (!String(sum).includes(".")) return sum;
    return (Math.round(sum * 100) / 100).toFixed(2);
  }
};
